import PromisedResource from './PromisedResource'

export default class ContractsResource extends PromisedResource {
  constructor({remote, clientId}) {
    super(remote.query(q => clientId ? q.findRelatedRecords({type: 'client', id: clientId}, 'contracts') : q.findRecords('contract'))) // TODO: for vendors, allow parent record to be a vendor
  }
}
